import { Plus, Trash2 } from "lucide-react";

const cell = "w-full bg-transparent border border-transparent focus:border-[#f59e0b] outline-none px-2 py-1.5 text-xs mono text-[#f8fafc]";

// Generic editable rows table. columns: [{key, label, type, options, width}]
export function RowsEditor({ rows, setRows, columns, newRow, testid, addLabel, renderExtra }) {
  const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div data-testid={testid} className="border border-[#334155] overflow-x-auto">
      <table className="w-full text-xs">
        <thead className="bg-[#0b0e13]">
          <tr>
            <th className="px-2 py-2 text-left mono text-[10px] text-[#64748b] w-10">#</th>
            {columns.map((c) => (
              <th key={c.key} className="px-2 py-2 text-left mono text-[10px] uppercase tracking-wider text-[#94a3b8]" style={{ minWidth: c.width }}>
                {c.label}
              </th>
            ))}
            {renderExtra && <th className="px-2 py-2 text-right mono text-[10px] uppercase tracking-wider text-[#94a3b8]">{renderExtra.label}</th>}
            <th className="w-8" />
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.key} className="border-t border-[#334155]/60 hover:bg-[#0b0e13]/60">
              <td className="px-2 mono text-[#64748b]">{i + 1}</td>
              {columns.map((c) => (
                <td key={c.key} className="px-0.5">
                  {c.options ? (
                    <select data-testid={`${testid}-${c.key}-${i}`} className={`${cell} bg-[#11151c]`} value={r[c.key]} onChange={(e) => set(i, c.key, e.target.value)}>
                      {c.options.map((o) => <option key={o} value={o}>{o}</option>)}
                    </select>
                  ) : (
                    <input
                      data-testid={`${testid}-${c.key}-${i}`}
                      className={cell}
                      type={c.type === "number" ? "number" : "text"}
                      inputMode={c.type === "number" ? "decimal" : undefined}
                      step="any"
                      value={r[c.key]}
                      onChange={(e) => set(i, c.key, e.target.value)}
                    />
                  )}
                </td>
              ))}
              {renderExtra && <td className="px-2 text-right mono text-[#fbbf24]">{renderExtra.render(r, i)}</td>}
              <td className="px-1">
                <button data-testid={`${testid}-del-${i}`} onClick={() => setRows(rows.filter((_, j) => j !== i))} className="p-1 text-[#64748b] hover:text-[#ef4444] transition-colors">
                  <Trash2 className="w-3.5 h-3.5" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button data-testid={`${testid}-add`} onClick={() => setRows([...rows, newRow()])} className="w-full flex items-center justify-center gap-1 py-2 border-t border-[#334155] mono text-[10px] uppercase tracking-widest text-[#94a3b8] hover:text-[#f59e0b] transition-colors">
        <Plus className="w-3 h-3" /> {addLabel}
      </button>
    </div>
  );
}
